/* eslint-disable: react/no-unused-prop-types */
import { Stack } from '@chakra-ui/react';
import React from 'react';

import { noop } from '@blockpulse3/data/shared';
import { DraftAgent } from '@blockpulse3/graphql/hooks';

import { draftAgentDefaultValues } from '../OnboardingSPV/OnboardingSPVWizard/provider/schema';
import { NaturalOtherRoleForm } from './NaturalOtherRoleForm';

type Props = {
  /* ** Are switches disabled ** */
  shouldDisabledSwitches?: boolean;
  /* ** Default form values for the Legal and Natural form version ** */
  defaultValues?: DraftAgent;
  /* ** Callback on natural switch toggle ** */
  onToggleNaturalSwitch?: (isNatural: boolean) => void;
  /* ** Callback on legal switch toggle ** */
  onToggleLegalSwitch?: (isLegal: boolean) => void;
  /* ** Callback of the Cancel button ** */
  onCancel?: () => void;
  /* ** Callback of the Submit button ** */
  onSubmit: (data: DraftAgent) => void;
};

/**
 * OtherRoleForm.
 * Main form that groups the legal and natural version of it.
 * It uses a forwardRef function to submit them from the outside.
 */
export const OtherRoleForm = React.forwardRef<HTMLFormElement, Props>((props, ref) => {
  const { defaultValues = draftAgentDefaultValues, onCancel = noop, onSubmit } = props;

  // Other legal roles are disabled for now, we keep the logic commented for later use
  // The related props are also disabled with the eslint switch
  //
  // const i18nGeneral = useTranslations('General')

  // const mainIdentity = useMainIdentity()

  /* ** Disclosure to control the legal switch ** */
  // const { isOpen: isLegal, onToggle: toggleIsLegal } = useDisclosure({
  // 	defaultIsOpen: defaultValues.isLegal,
  // })
  // /* ** Disclosure to control the natural switch ** */
  // const { isOpen: isNatural, onToggle: toggleIsNatural } = useDisclosure({
  // 	defaultIsOpen: false,
  // })

  // /* ** Natural switch callback ** */
  // const handleToggleNaturalSwitch = (): void => {
  // 	if (isLegal) {
  // 		toggleIsLegal()
  // 	}
  // 	toggleIsNatural()
  // 	/* ** Step switch specific callback ** */
  // 	onToggleNaturalSwitch(!isNatural)
  // }

  // /* ** Legal switch callback ** */
  // const handleToggleLegalSwitch = (): void => {
  // 	if (isNatural) {
  // 		toggleIsNatural()
  // 	}
  // 	toggleIsLegal()
  // 	/* ** Step switch specific callback ** */
  // 	onToggleLegalSwitch(!isLegal)
  // }

  /* ** Submit whatever other role form is being rendered ** */
  const handleSubmit = (data: DraftAgent): void => {
    onSubmit(data);
  };

  /* ** Cancel whatever other role form is being rendered ** */
  const handleCancel = (): void => {
    onCancel();
  };

  return (
    <Stack spacing="4">
      <NaturalOtherRoleForm
        defaultValues={defaultValues}
        ref={ref}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
      />
    </Stack>
  );
});

OtherRoleForm.displayName = 'OtherRoleForm';

export type OtherRoleFormProps = Props;
